<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <Filter
                            :dateRange="false"
                            :nation="false"
                            :selectOption="state.selectOption"
                            @search="filterSearch"
                            @reset="resetSearch"
                        ></Filter>
                        <div class="board_condition">
                            <div class="board_condition_con">
                                <span class="bc_main_tit">검색조건</span>
                                <span>{{ result.detail.strType }}</span>
                                <span class="bc_line"></span>
                                <div class="bc_result">
                                    <span v-if="result.detail.keyword">{{ result.detail.keyword }}</span>
                                    <span v-if="result.detail.imgPath && result.detail.keyword">+</span>
                                    <button
                                        type="button"
                                        class="bc_thumb"
                                        @click="showImg(result.detail.imgPath)"
                                        v-if="result.detail.imgPath"
                                    >
                                        <img :src="result.detail.imgPath" />
                                    </button>
                                </div>
                                <span class="bc_line"></span>
                                <div class="bc_sns">
                                    <img src="@/assets/sns/Twitter.png" v-if="result.detail.isTwitter" />
                                    <img src="@/assets/sns/Bluesky.png" v-if="result.detail.isBluesky" />
                                    <img src="@/assets/sns/Google.png" v-if="result.detail.isGoogle" />
                                    <img src="@/assets/sns/Naver.png" v-if="result.detail.isNaver" />
                                    <img src="@/assets/sns/Youtube.png" v-if="result.detail.isYoutube" />
                                    <img src="@/assets/sns/Instagram.png" v-if="result.detail.isInstagram" />
                                </div>
                                <span class="bc_line"></span>
                                <p class="bc_nation">
                                    {{ result.detail.strNation?.join(", ") }}
                                </p>
                            </div>
                            <div class="bc_info">
                                <span class="bc_tit">담당자</span>
                                <span class="bc_info_txt">{{ result.detail.meName }}</span>
                                <span class="bc_tit">검색일</span>
                                <span class="bc_info_txt">{{ result.detail.createDate ? formatDate(result.detail.createDate) : "" }}</span>
                            </div>
                        </div>
                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn" @click="checkbtn(0)">전체선택</button>
                                <button type="button" class="board_btn board_ico_btn" @click="excelDownLoad">
                                    <span>엑셀다운로드</span>
                                    <img src="@/assets/board/excel_ico.png" />
                                </button>
                            </div>
                            <div class="board_top_btns_right">
                                <div class="count">{{ numberFormat(state.totalLength) }}건</div>
                                <select name="" id="" class="select" v-model.number="state.perPage">
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="70">70</option>
                                    <option value="100">100</option>
                                </select>
                                <div class="change_list_btns">
                                    <button
                                        type="button"
                                        class="list_btn"
                                        :class="state.layer === 0 ? 'on' : ''"
                                        @click="changeLayer(0)"
                                    ></button>
                                    <button
                                        type="button"
                                        class="gal_btn"
                                        :class="state.layer === 1 ? 'on' : ''"
                                        @click="changeLayer(1)"
                                    ></button>
                                </div>
                            </div>
                        </div>
                        <div class="gal_list_wrap" :class="state.layer === 1 ? 'card' : ''">
                            <div class="board_cate_btns">
                                <button type="button" @click="updateCheckLists(2)">모니터링</button>
                                <button type="button" @click="updateCheckLists(1)">삭제</button>
                            </div>
                            <template v-if="!state.isLoading">
                                <template v-if="result.list.length !== 0">
                                    <ul :class="state.layer === 0 ? 'gal_list' : 'gal_list_v2'">
                                        <li v-for="(item, idx) in result.list" :class="item.monitoringState === 4 ? 'off' : ''">
                                            <div :class="state.layer === 0 ? 'gal_list_con' : 'gal_con'">
                                                <template v-if="state.layer === 0">
                                                    <div>
                                                        <label class="chk">
                                                            <input type="checkbox" name="" id="" v-model="state.checkList[idx]" />
                                                            <span></span>
                                                        </label>
                                                        <span class="info_ico" v-if="item.isMonitoring === 1 && item.hasMonitoring === 0">
                                                            <img src="@/assets/board/info_ico.png" />
                                                        </span>
                                                    </div>
                                                    <div class="gal_thumb" @click="isDetailModal(item.idx)">
                                                        <div class="gal_thumb_img">
                                                            <img
                                                                :class="{ blur: item.imgPath }"
                                                                :src="item.imgPath ? item.imgPath : require('@/assets/common/NoImg.png')"
                                                                @error="imgError"
                                                            />
                                                        </div>
                                                        <span class="sns_ico">
                                                            <img v-if="item.sns === 1" src="@/assets/sns/twitter_ico.png" />
                                                            <img v-if="item.sns === 2" src="@/assets/sns/google_ico.png" />
                                                            <img v-if="item.sns === 3" src="@/assets/sns/naver_ico.png" />
                                                            <img v-if="item.sns === 4" src="@/assets/sns/youtube_ico.png" />
                                                            <img v-if="item.sns === 5" src="@/assets/sns/instargram_ico.png" />
                                                            <img v-if="item.sns === 6" src="@/assets/sns/bluesky_ico.png" />
                                                        </span>
                                                    </div>
                                                    <div class="gal_thumb_info_div">
                                                        <ul class="gal_info_list">
                                                            <li class="gal_info_top">
                                                                <div class="gal_info_tit">
                                                                    <b>순번</b>
                                                                    <span>
                                                                        {{
                                                                            state.currentPage === 1
                                                                                ? idx + 1
                                                                                : state.perPage * (state.currentPage - 1) + idx + 1
                                                                        }}
                                                                    </span>
                                                                </div>
                                                                <div class="gal_info_con">
                                                                    <b>검색유형</b>
                                                                    <span>
                                                                        {{
                                                                            item.searchType === 1
                                                                                ? "키워드"
                                                                                : item.searchType === 2
                                                                                  ? "이미지"
                                                                                  : item.searchType === 3
                                                                                    ? "키워드 + 이미지"
                                                                                    : "잘못된 값"
                                                                        }}
                                                                    </span>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">고유번호</div>
                                                                <div class="gal_info_con">{{ item.idx }}</div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">국적</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.strNation }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">내용</div>
                                                                <div class="gal_info_con" v-html="item.title"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">해시태그</div>
                                                                <div class="gal_info_con" v-html="item.hashtag"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">URL</div>
                                                                <div class="gal_info_con">
                                                                    <a :href="item.siteUrl" target="_blank">
                                                                        {{ item.siteUrl }}
                                                                    </a>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">등록일자</div>
                                                                <div class="gal_info_con">
                                                                    {{ formatDate(item.createDate) }}
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        <ul class="gal_info_list">
                                                            <li>
                                                                <div class="gal_info_tit">글쓴이(계정)</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.author }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">메신저 ID</div>
                                                                <div class="gal_info_con">
                                                                    <div class="sns_id">
                                                                        <p>{{ item.messengerId }}</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">전화번호</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.phoneNum }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">근거내용</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.reasonContent }}
                                                                </div>
                                                            </li>

                                                            <li>
                                                                <div class="gal_info_tit">유형</div>
                                                                <select
                                                                    class="select"
                                                                    v-model.number="item.type"
                                                                    @change="item.detailType = getDetailTypeFilter(item.type)[0].idx"
                                                                >
                                                                    <option :value="type.idx" v-for="type in state.typeList">
                                                                        {{ type.name }}
                                                                    </option>
                                                                </select>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">세부유형</div>
                                                                <div class="gal_info_save_box">
                                                                    <select
                                                                        class="select"
                                                                        v-model.number="item.detailType"
                                                                        @change="changeDetailType(item)"
                                                                    >
                                                                        <option
                                                                            :value="dType.idx"
                                                                            v-for="dType in getDetailTypeFilter(item.type)"
                                                                        >
                                                                            {{ dType.name }}
                                                                        </option>
                                                                    </select>
                                                                    <input type="text" v-if="item.detailType === 6" v-model="item.detail" />
                                                                    <button type="button" class="save_btn" @click="saveList(idx)">
                                                                        저장
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div class="gal_btn_div">
                                                        <template v-if="item.state !== 0 && item.state !== null">
                                                            <span v-if="item.similarity">
                                                                유사도
                                                                <b>{{ item.similarity }}</b>
                                                                %
                                                            </span>
                                                        </template>
                                                        <template v-else>
                                                            <Spinner class="resultProgress"></Spinner>
                                                        </template>
                                                        <button
                                                            type="button"
                                                            class="monitoring_btn"
                                                            :class="item.isMonitoring === 1 && item.hasMonitoring === 1 ? 'on' : ''"
                                                            @click="isMonitoring(idx)"
                                                        ></button>
                                                    </div>
                                                </template>
                                                <template v-if="state.layer === 1">
                                                    <div class="gal_top_box">
                                                        <div class="gal_top_left">
                                                            <label class="chk">
                                                                <input type="checkbox" v-model="state.checkList[idx]" />
                                                                <span></span>
                                                            </label>
                                                            <span v-if="item.isMonitoring === 1 && item.hasMonitoring === 0">
                                                                <img src="@/assets/board/info_ico.png" />
                                                            </span>
                                                        </div>
                                                        <div class="gal_thumb">
                                                            <div class="gal_thumb_img">
                                                                <img
                                                                    :class="{ blur: item.imgPath }"
                                                                    :src="
                                                                        item.imgPath ? item.imgPath : require('@/assets/common/NoImg.png')
                                                                    "
                                                                    @error="imgError"
                                                                    @click="isDetailModal(item.idx)"
                                                                />
                                                            </div>
                                                            <span class="sns_ico">
                                                                <img v-if="item.sns === 1" src="@/assets/sns/twitter_ico.png" />
                                                                <img v-if="item.sns === 2" src="@/assets/sns/google_ico.png" />
                                                                <img v-if="item.sns === 3" src="@/assets/sns/naver_ico.png" />
                                                                <img v-if="item.sns === 4" src="@/assets/sns/youtube_ico.png" />
                                                                <img v-if="item.sns === 5" src="@/assets/sns/instargram_ico.png" />
                                                                <img v-if="item.sns === 6" src="@/assets/sns/bluesky_ico.png" />
                                                            </span>
                                                        </div>
                                                        <div class="gal_top_txt">
                                                            <button
                                                                type="button"
                                                                class="monitoring_btn"
                                                                :class="item.isMonitoring === 1 && item.hasMonitoring === 1 ? 'on' : ''"
                                                                @click="isMonitoring(idx)"
                                                            ></button>
                                                            <div>
                                                                <div class="gal_info_top_box">
                                                                    <p class="gal_info_top">
                                                                        <b>순번</b>
                                                                        <span>
                                                                            {{
                                                                                state.currentPage === 1
                                                                                    ? idx + 1
                                                                                    : state.perPage * (state.currentPage - 1) + idx + 1
                                                                            }}
                                                                        </span>
                                                                    </p>
                                                                    <p class="gal_info_top">
                                                                        <b>국적</b>
                                                                        <span>{{ item.strNation }}</span>
                                                                    </p>
                                                                </div>
                                                                <div class="gal_btn_div" v-if="item.similarity">
                                                                    <span>
                                                                        유사도
                                                                        <b>{{ item.similarity }}</b>
                                                                        %
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="gal_info_div">
                                                        <ul class="gal_info_list">
                                                            <li>
                                                                <div class="gal_info_tit">고유번호</div>
                                                                <div class="gal_info_con">{{ item.idx }}</div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">내용</div>
                                                                <div class="gal_info_con" v-html="item.title"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">해시태그</div>
                                                                <div class="gal_info_con" v-html="item.hashtag"></div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">URL</div>
                                                                <div class="gal_info_con">
                                                                    <a :href="item.siteUrl" target="_blank">
                                                                        {{ item.siteUrl }}
                                                                    </a>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">등록일자</div>
                                                                <div class="gal_info_con">
                                                                    {{ formatDate(item.createDate) }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">글쓴이(계정)</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.author }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">메신저</div>
                                                                <div class="gal_info_con">
                                                                    <div class="sns_id">
                                                                        <p>{{ item.messengerId }}</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">전화번호</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.phoneNum }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">근거내용</div>
                                                                <div class="gal_info_con">
                                                                    {{ item.reasonContent }}
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">유형</div>
                                                                <select
                                                                    class="select"
                                                                    v-model.number="item.type"
                                                                    @change="item.detailType = getDetailTypeFilter(item.type)[0].idx"
                                                                >
                                                                    <option :value="type.idx" v-for="type in state.typeList">
                                                                        {{ type.name }}
                                                                    </option>
                                                                </select>
                                                            </li>
                                                            <li>
                                                                <div class="gal_info_tit">세부유형</div>
                                                                <div class="gal_info_save_box">
                                                                    <select
                                                                        name=""
                                                                        id=""
                                                                        class="select"
                                                                        v-model.number="item.detailType"
                                                                        @change="changeDetailType(item)"
                                                                    >
                                                                        <option
                                                                            :value="dType.idx"
                                                                            v-for="dType in getDetailTypeFilter(item.type)"
                                                                        >
                                                                            {{ dType.name }}
                                                                        </option>
                                                                    </select>
                                                                    <input
                                                                        type="text"
                                                                        name=""
                                                                        id=""
                                                                        v-if="item.detailType === 6"
                                                                        v-model="item.detail"
                                                                    />
                                                                    <button type="button" class="save_btn" @click="saveList(idx)">
                                                                        저장
                                                                    </button>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </template>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                                <template v-else>
                                    <NoResult class="result_load"></NoResult>
                                </template>
                                <PageBtn
                                    v-if="result.list.length !== 0 && !state.isLoading"
                                    :currentPage="state.currentPage"
                                    :totalLength="state.totalLength"
                                    :perPage="state.perPage"
                                    @onPaging="handlePageChange"
                                ></PageBtn>
                            </template>
                            <template v-else>
                                <Spinner :isLoading="state.isLoading" class="result_load"></Spinner>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Popup :show="state.isModalOpen" :title="modal.title" :content="modal.content" @close="modalClose"></Popup>
</template>
<script lang="ts">
    import {
        apiService,
        Header,
        Menu,
        onMounted,
        reactive,
        returnCode,
        PageBtn,
        numberFormat,
        formatDate,
        res,
        useRoute,
        watch,
        userStore,
        NoResult,
        Filter,
        globalStore,
        router,
        Popup,
        Spinner,
        detailInfo,
        resultInfo,
    } from "@/BaseComponent";
    export default {
        props: [],
        components: {
            Header,
            Menu,
            PageBtn,
            Filter,
            NoResult,
            Popup,
            Spinner,
        },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const resultIdx = route.params.idx as any;

            const { changeCode } = returnCode();
            const state = reactive({
                isLoading: true,
                checkAll: false as boolean,
                checkList: [] as Array<boolean>,
                selectOption: [
                    { idx: 1, text: "내용" },
                    { idx: 2, text: "URL" },
                    { idx: 3, text: "글쓴이" },
                    { idx: 4, text: "고유번호" },
                ] as Array<any>,
                isModalOpen: false,
                layer: 0 as number,
                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 100 as number,
                typeList: [] as any,
                detailTypeList: [] as any,
                filterData: {} as any,
            });
            const result = reactive({
                list: [] as Array<any>,
                detail: {} as any,
            });
            const modal = reactive({
                title: "" as string,
                content: {
                    title: "" as string,
                    main: {
                        title: "검색정보" as string,
                        data: "" as any,
                        class: "thumb_con",
                        render: (data: any) => {
                            return detailInfo(data);
                        },
                    },
                    subTitle: "검색결과" as string,
                    class: "thumb_con",
                    sub: {
                        title: "" as string,
                        data: "" as any,
                        class: "thumb_con",
                        render: (data: any) => {
                            let type = state.typeList.find((item: any) => item.idx === data.type)?.name;
                            let detailType = "";
                            detailType =
                                data.detailType !== 6
                                    ? state.detailTypeList.find((item: any) => item.idx === data.detailType)?.name
                                    : `기타(${data.detail})`;

                            return resultInfo(data, type, detailType);
                        },
                    },
                    img: {
                        data: "" as any,
                        name: "" as any,
                        render: (data: any) => {
                            return data ? data : `<img src="${require("@/assets/common/NoImg.png")}" alt="이미지 없음" />`;
                        },
                    } as any,
                } as any,
            });
            onMounted(() => {
                getDetailInfo();
                global.setSelectMenu(1);
                if (user.perPage) state.perPage = user.perPage;
                if (user.listLayer) state.layer = user.listLayer;
                global.type.length !== 0 ? (state.typeList = global.type) : getTypeList();
                global.detailType.length !== 0 ? (state.detailTypeList = global.detailType) : getDetailTypeList();
            });

            watch(
                () => state.perPage,
                () => {
                    user.setPerPage(state.perPage);
                    state.currentPage = 1;
                    getResultList();
                },
            );

            const getDetailInfo = async () => {
                const res = await apiService.search.detailInfo(resultIdx);
                if (res.returnCode === 0) {
                    modal.content.main.data = result.detail = res.data;
                } else if (res.returnCode !== 11) {
                    alert(changeCode(res.returnCode));
                }
            };

            const getTypeList = async () => {
                const res: res = await apiService.base.getTypeList();
                if (res.returnCode === 0) {
                    state.typeList = res.list.filter((r: any) => r.idx < 2);
                } else {
                    changeCode(res.returnCode);
                }
            };

            const getDetailTypeList = async () => {
                const res: res = await apiService.base.getDetailTypeList();
                if (res.returnCode === 0) {
                    state.detailTypeList = res.list;
                } else {
                    console.warn(changeCode(res.returnCode));
                }
            };

            const getResultList = async () => {
                state.isLoading = true;
                const res = await apiService.search.getResultList(parseInt(resultIdx), state.perPage, state.currentPage, state.filterData);
                if (res.returnCode === 0) {
                    result.list = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                    for (let i = 0; i < res.list.data.length; i++) {
                        state.checkList[i] = false;
                    }
                } else if (res.returnCode === 3) {
                    router.replace("/403");
                } else {
                    alert(changeCode(res.returnCode));
                }
                state.isLoading = false;
            };

            const getResultDetail = async (idx: number) => {
                const res = await apiService.search.getResultDetail(idx);
                if (res.returnCode === 0) {
                    modal.title = "검색조건";
                    modal.content.main.data = result.detail;
                    modal.content.sub.data = res.data;
                    modal.content.img.data = res.data.imgPath;
                    modal.content.img.name = res.data.imgName;
                } else {
                    console.warn(changeCode(res.returnCode));
                }
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getResultList();
            };

            const saveList = async (idx: number) => {
                if (result.list[idx].detailType === null) {
                    if (result.list[idx].detailType === 6) {
                        if (result.list[idx].detail === null) {
                            return alert("기타 선택 시 값은 필수입니다.");
                        }
                        if (result.list[idx].detail?.trim() === "") {
                            return alert("세부유형의 상세 값을 확인해주세요");
                        }
                    }
                    const res = await apiService.search.saveResultType(
                        result.list[idx].idx,
                        result.list[idx].type,
                        result.list[idx].detailType,
                        result.list[idx].detail,
                    );
                    if (res.returnCode === 0) {
                        return alert("변경 완료되었습니다.");
                    } else if (res.returnCode !== 11) {
                        alert(changeCode(res.returnCode));
                    }
                } else {
                    alert("세부유형을 선택해주세요");
                }
            };

            const changeLayer = (idx: number) => {
                state.layer = idx;
                user.setListLayer(idx);
            };

            const filterSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getResultList();
            };

            const resetSearch = (data: any) => {
                state.currentPage = 1;
                state.filterData = data;
                getResultList();
            };

            const isMonitoring = async (idx: number) => {
                const res = await apiService.search.isMonitoring(result.list[idx].idx);
                if (res.returnCode === 0) {
                    result.list[idx].isMonitoring = 1;
                    if (result.list[idx].hasMonitoring === 0) {
                        result.list[idx].hasMonitoring = 1;
                    } else if (result.list[idx].hasMonitoring === 1) {
                        result.list[idx].hasMonitoring = 0;
                    }
                } else if (res.returnCode !== 11) {
                    alert(changeCode(res.returnCode));
                }
            };

            const isDetailModal = (idx: number) => {
                modal.content.img.data = "";
                modal.content.img.name = "";
                state.isModalOpen = true;
                getResultDetail(idx);
            };

            const modalClose = () => {
                state.isModalOpen = false;
            };

            const checkbtn = (idx: number) => {
                if (idx === 0) {
                    state.checkAll = !state.checkAll;
                    for (let i = 0; i < state.checkList.length; i++) {
                        state.checkList[i] = state.checkAll;
                    }
                }
            };

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/common/NoImg.png");
                }
            };

            const excelDownLoad = async () => {
                let checkedIdx = "" as any;
                if (state.checkList.some((value) => value === true)) {
                    checkedIdx = result.list.filter((item: any, index: number) => state.checkList[index]).map((item: any) => item.idx);
                }

                const res: any = await apiService.excel.resultList(
                    resultIdx,
                    state.currentPage,
                    state.perPage,
                    state.filterData,
                    checkedIdx ? checkedIdx.join(", ") : null,
                );
                if (res.status === 200) {
                    const blob = res.data;
                    const fileUrl = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.download = "검색결과_" + result.detail.keyword + ".xlsx";
                    link.href = fileUrl;
                    link.click();
                    URL.revokeObjectURL(fileUrl);
                    return alert("다운로드 완료 되었습니다.");
                } else {
                    console.error(res);
                    alert("다운로드 중 오류가 발생했습니다.");
                }
            };

            const changeDetailType = (data: any) => {
                if (data.detailType !== 6) {
                    result.list.find((item: any) => item.idx === data.idx).detail = "";
                }
            };

            const updateCheckLists = async (status: number) => {
                let res = {} as res;
                if (state.checkList.some((item) => item === true)) {
                    let checkedIdx = "" as any;
                    checkedIdx = result.list.filter((item: any, index: number) => state.checkList[index]).map((item: any) => item.idx);
                    switch (status) {
                        case 1:
                            if (confirm("선택된 결과를 삭제하시겠습니까?")) {
                                res = await apiService.search.multiDelete(checkedIdx.join(","));
                                if (res.returnCode === 0) {
                                    getResultList();
                                    alert(`총 ${res.successCnt}개의 결과가 삭제되었습니다.`);
                                } else {
                                    alert(changeCode(res.returnCode));
                                }
                            }
                            break;
                        case 2:
                            if (confirm("선택된 결과를 모니터링에 추가하시겠습니까?")) {
                                res = await apiService.search.multiMonitoring(checkedIdx.join(","));
                                if (res.returnCode === 0) {
                                    getResultList();
                                    alert(`총 ${checkedIdx.length}개 중 ${res.successCnt}개가 모니터링에 추가되었습니다.`);
                                } else {
                                    alert(changeCode(res.returnCode));
                                }
                            }
                            break;
                    }
                } else {
                    return alert("선택된 목록이 없습니다.");
                }
            };

            const showImg = (value: any) => {
                modal.title = "검색이미지";
                modal.content.main.data = "";
                modal.content.img.data = value ? value : require("@/assets/common/NoImg.png");
                state.isModalOpen = true;
            };

            const getDetailTypeFilter = (typeIdx: number) => {
                return state.detailTypeList.filter((item: any) => item.typeIdx === typeIdx);
            };

            return {
                state,
                result,
                handlePageChange,
                numberFormat,
                formatDate,
                saveList,
                changeLayer,
                filterSearch,
                isMonitoring,
                resetSearch,
                isDetailModal,
                modal,
                modalClose,
                checkbtn,
                imgError,
                excelDownLoad,
                changeDetailType,
                updateCheckLists,
                showImg,
                getDetailTypeFilter,
            };
        },
    };
</script>

<style scoped>
    .result_load {
        box-sizing: border-box;
        background-color: #fff;
        position: relative;
        width: 100%;
        max-width: 1600px;
        height: 360px;
    }
    #board_layer .gal_info_list > li .gal_info_con {
        max-width: 400px;
        line-height: 1.3;
    }
    #board_layer .gal_list .gal_list_con {
        padding: 20px 0px;
    }
    #board_layer .board_cate_btns {
        left: 292px;
    }
</style>

<style>
    #board_layer .board_condition {
        max-height: 30px;
    }

    #board_layer .bc_result .bc_thumb {
        height: 60px;
    }

    #board_layer .gal_info_list > li .gal_info_con > a {
        text-decoration: underline;
        color: #5c5c5c;
        text-underline-position: from-font;
    }

    #board_layer .gal_thumb_img img,
    .pop_layer .thumb_con .thumb img {
        object-fit: contain;
    }

    .pop_layer .thumb_con .txt li .link span {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .pop_con_w_50 .pop_con_desc {
        width: 220px;
    }

    .copy_btn {
        background-color: unset;
        cursor: pointer;
    }

    .url_con {
        text-decoration: underline;
        text-underline-position: under;
        color: #5c5c5c;
        display: block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .pop_layer .thumb_con .txt li .pop_con_desc > span {
        width: 80%;
        display: inline-block;
    }

    .gal_list_con.no_list,
    .gal_con.no_list {
        min-width: 360px;
    }

    .resultProgress {
        width: auto !important;
        padding: 0 !important;
    }

    .resultProgress .spinner {
        border-top: 6px solid red;
        width: 25px;
        height: 25px;
    }
</style>
